import createClient from '@mapbox/mbxxhr';
import createAuthentication from '@mapbox/mbxxhr/services/authentication';
import createServiceFactory from '@mapbox/mapbox-sdk/services/service-helpers/create-service-factory';

import * as v from '@mapbox/mapbox-sdk/services/service-helpers/validator';

const mapboxClient = createClient({
  environment:
    process.env.DEPLOY_ENV === 'production' ? 'production' : 'staging'
});

const authenticationService = createAuthentication(mapboxClient);
let getUserCache;
const getUser = () => {
  if (getUserCache) return getUserCache;
  getUserCache = authenticationService
    .getSession()
    .send()
    .then(response => response.body)
    .catch(error => {
      if (error.statusCode === 403) {
        return null;
      }
      throw error;
    });
  return getUserCache;
};

const Software = {};

// v1 endpoint
Software.getSoftwarev1 = function(config) {
  v.assertShape({
    software: v.required(v.string)
  })(config);
  return this.client.createRequest({
    method: 'GET',
    path: `/v1/software/${config.software}`
  });
};

// v2 endpoints
Software.listSoftware = function(config) {
  v.assertShape({
    software: v.required(v.string)
  })(config);
  return this.client.createRequest({
    method: 'GET',
    path: `/v2/software/${config.software}`
  });
};

Software.getKubernetesVersions = function(config) {
  v.assertShape({})(config);
  return this.client.createRequest({
    method: 'GET',
    path: `/v2/software/charts/index.yaml`
  });
};

Software.getSoftware = function(config) {
  v.assertShape({
    software: v.required(v.string),
    version: v.required(v.string)
  })(config);
  return this.client.createRequest({
    method: 'GET',
    path: `/v2/software/${config.software}/${config.version}`
  });
};

Software.getLicense = function(config) {
  v.assertShape({})(config);
  return this.client.createRequest({
    method: 'GET',
    path: `/v2/software/license`
  });
};

Software.getDownloadLink = function(config) {
  v.assertShape({
    installerVersion: v.required(v.string)
  });
  return this.client.createRequest({
    method: 'GET',
    path: `v2/software/atlas-installer/${config.installerVersion}`
  });
};

const Offline = {};

Offline.getData = function(config) {
  v.assertShape({
    id: v.required(v.string)
  })(config);
  return this.client.createRequest({
    method: 'GET',
    path: '/v1/offline/:id',
    params: { id: config.id }
  });
};

const createSoftwareServiceClient = createServiceFactory(Software);
const createOfflineServiceClient = createServiceFactory(Offline);
const softwareService = createSoftwareServiceClient(mapboxClient);
const offlineService = createOfflineServiceClient(mapboxClient);

export { softwareService, offlineService, getUser, authenticationService };
